// extracted by mini-css-extract-plugin
module.exports = {"popupBody":"PopupBody-module--popup-body--35UTN"};